<template>
  <div v-show="showPopin" class="modal redirection-poppin" :class="{ visible: showPopin }">
    <div class="modal__overlay"></div>
    <div class="modal__body">
      <div class="modal__content">
        <div class="redirection-container">
          <div class="redirection-popin-buttons">
            <h1 class="redirection-popin-tittle">{{ redirectionData.popin_title }}</h1>
            <button
              class="close-button-text ripple-animation ripple-animation--black"
              @click="closePopup(redirectionData.popin_ctabutton_one)"
            >
              {{ redirectionData.popin_ctabutton_one }}
            </button>
            <a
              v-if="redirectionData.popin_ctabutton_two && redirectionData.popin_ctabutton_two_Text"
              class="redirection-button ripple-animation"
              :href="redirectionData.popin_ctabutton_two"
              @click="triggerDatalayer(redirectionData.popin_ctabutton_two_Text)"
              >{{ redirectionData.popin_ctabutton_two_Text }}</a
            >
            <a
              v-if="
                redirectionData.popin_ctabutton_three && redirectionData.popin_ctabutton_three_Text
              "
              class="redirection-button ripple-animation"
              :href="redirectionData.popin_ctabutton_three"
              @click="triggerDatalayer(redirectionData.popin_ctabutton_three_Text)"
              >{{ redirectionData.popin_ctabutton_three_Text }}</a
            >
          </div>
          <img :src="redirectionData.popin_bgimage" alt="Bg-image" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'redirection-popin',
  props: {
    redirectionData: { type: Object, required: true },
  },
  data() {
    return {
      showPopin: true,
    };
  },
  methods: {
    closePopup(buttonText) {
      this.showPopin = false;
      this.triggerDatalayer(buttonText);
    },
    triggerDatalayer(buttonText) {
      const btnText = buttonText ? buttonText.toLowerCase() : '';
      try {
          dataLayer.push({ //eslint-disable-line
          event: 'uaevent',
          ecommerce: 'undefined',
          eventCategory: 'are you profile',
          eventAction: `${'select::'}${btnText}`,
          eventLabel: '',
        });
      } catch {
        console.warn('datalayer is not defined');
      }
    },
  },
};
</script>
